export type AutoscaleConditionOperator = 'is' | 'is not' | 'contains' | "doesn't contain";

export type AutoscaleConditionType = 'cluster' | 'node' | 'instance' | 'instance_tag' | 'volume';

export type TagItem = {
  title: string;
  tag: AutoscaleConditionType;
};

export const autoscaleConditionTypes: TagItem[] = [
  {
    title: 'Cluster',
    tag: 'cluster',
  },
  {
    title: 'Node group',
    tag: 'node',
  },
  {
    title: 'Instance',
    tag: 'instance',
  },
  {
    title: 'Instance tag',
    tag: 'instance_tag',
  },
  {
    title: 'Volume tag',
    tag: 'volume',
  },
];

export const autoscaleConditionOperators: {
  title: string;
  operator: AutoscaleConditionOperator;
}[] = [
  {
    title: 'is',
    operator: 'is',
  },
  {
    title: 'is not',
    operator: 'is not',
  },
  {
    title: 'contains',
    operator: 'contains',
  },
  {
    title: "doesn't contain",
    operator: "doesn't contain",
  },
];
